<template>
  <l-legacy v-if="$m_ie_isLegacy"/>
  <l-kiosk v-else-if="mode === 'kiosk'">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </l-kiosk>
  <l-default v-else-if="mode && ($mq === 'md' || $mq === 'lg')" :device="$mq" :ie="$m_ie_isLegacy">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </l-default>
  <l-mobile v-else-if="mode" :device="$mq" :ie="$m_ie_isLegacy">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </l-mobile>
</template>

<script>
import { mapGetters } from 'vuex';

import ieMixin from './app/mixins/ie';

export default {
  name: 'App',
  mixins: [
    ieMixin
  ],
  computed: {
    ...mapGetters({
      mode: 'simulation/getMode'
    })
  },
  mounted() {
    document.addEventListener('gesturestart', e => e.preventDefault());

    document.oncontextmenu = () => this.mode !== 'kiosk';
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue